import { Type } from 'class-transformer';
import { IsDefined, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { PropertyOfferType, PropertyResidenceType, PropertyType } from './property-enums';
import { PropertySellerDto } from './property-seller.dto';

export class PropertyDefinitionDto {
  @IsEnum(PropertyOfferType)
  offerType!: PropertyOfferType;

  @IsEnum(PropertyType)
  propertyType!: PropertyType;

  @IsOptional()
  @IsEnum(PropertyResidenceType)
  residenceType?: PropertyResidenceType;

  @IsOptional()
  @IsString()
  reference?: string;

  @IsDefined()
  @ValidateNested()
  @Type(() => PropertySellerDto)
  seller: PropertySellerDto = new PropertySellerDto();
}
